import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import {
  HOTEL_CONTACT_CODES,
  getAuthErrorMessageId,
  retryMinutes
} from "../../helpers/authErrors";

// Datos de contacto del hotel (teléfono y mail) de PosData / ProductData.
export const getHotelContact = (PosData, ProductData) => {
  const pos = PosData || {};
  const product = ProductData || {};
  return [
    pos.Phone || product.telefono,
    pos.Email || pos.email || product.email
  ]
    .filter(Boolean)
    .join(" / ");
};

// Mensaje claro según el `code` que devolvió api2 (login, magic link o canje
// del token de acceso). `invalid_credentials` mantiene el texto genérico de
// siempre para no revelar si la reserva existe.
const AuthErrorNotice = ({
  info,
  PosData,
  ProductData,
  onUseMagicLink,
  showMagicLinkOffer
}) => {
  if (!info) return null;
  const messageId = getAuthErrorMessageId(info);
  const contact = HOTEL_CONTACT_CODES.indexOf(info.code) !== -1
    ? getHotelContact(PosData, ProductData)
    : "";
  return (
    <Box pb={2}>
      <Alert
        severity={info.code === "logged_out" ? "success" : "error"}
        role="alert"
      >
        <FormattedMessage
          id={messageId}
          values={{ minutes: retryMinutes(info.retryAfter) }}
        />
        {contact ? (
          <Box mt={1}>
            <FormattedMessage
              id="login.errors.hotelContact"
              values={{ contact }}
            />
          </Box>
        ) : null}
        {info.code === "too_many_attempts" && showMagicLinkOffer ? (
          <Box mt={1}>
            <Button
              size="small"
              color="primary"
              variant="outlined"
              onClick={onUseMagicLink}
            >
              <FormattedMessage id="login.errors.useMagicLink" />
            </Button>
          </Box>
        ) : null}
      </Alert>
    </Box>
  );
};

export default AuthErrorNotice;
